import { __decorate } from "tslib";
import { LitElement, html, css } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { classMap } from 'lit/directives/class-map.js';
import { elements } from './sdb-elements.js';
/**
 * Summary element, used to wrap summaryitem elements (max 4)
 *
 * @slot 1 - the first slot
 * @slot 2 - the second slot
 * @slot 3 - the third slot
 * @slot 4 - the fourth slot
 *
 * @prop bg - optional, used to set a background image
 * @prop bgColor - optional, used to set an overlay color
 * @prop noPadding - optional, removes padding
 *
 */
let SDBContentSummary = class SDBContentSummary extends LitElement {
    constructor() {
        super(...arguments);
        this.bg = '';
        this.bgColor = '';
        this.noPadding = false;
        this.equalWidthColumns = false;
    }
    render() {
        return html `
            <div
                class="backgroundImage"
                style="background-image:url('${this.bg}');"
            ></div>
            <slot class="slot0"></slot>
            <section class=${classMap({ equal: this.equalWidthColumns })}>
                <slot name="1" class="summaryItem"></slot>
                <slot name="2" class="summaryItem"></slot>
                <slot name="3" class="summaryItem"></slot>
                <slot name="4" class="summaryItem"></slot>
            </section>

            <div
                class="overlay"
                style="background:${this.bgColor};"
                part="overlay"
            ></div>
        `;
    }
};
SDBContentSummary.styles = [
    elements,
    css `
            :host {
                position: relative;
                padding: 35px;
                display: grid;
            }

            @media only screen and (max-width: 767px) {
                /* For mobile phones: */
                :host {
                    padding: 15px;
                }
            }

            :host([nopadding]) {
                padding: 15px 0;
            }

            .backgroundImage {
                background-repeat: no-repeat;
                background-size: cover;
                background-position: center center;
                -webkit-filter: grayscale(100%); /* Safari 6.0 - 9.0 */
                filter: grayscale(100%);
                display: block;
                width: 100%;
                height: 100%;
                position: absolute;
                top: 0;
                left: 0;
            }

            .slot0::slotted(*) {
                z-index: 2;
            }

            .overlay {
                position: absolute;
                z-index: 1;
                width: 100%;
                height: 100%;
                background: var(--theme-tertiary);
                opacity: 0.9;
                top: 0;
                left: 0;
            }

            section {
                display: grid;
                grid-template-rows: auto;
                grid-auto-columns: fit-content;
                grid-auto-flow: column;
                justify-items: stretch;
                align-items: stretch;
                z-index: 2;
                position: relative;
            }

            section.equal {
                grid-auto-columns: 1fr;
            }

            @media only screen and (max-width: 767px) {
                /* For mobile phones: */
                section {
                    grid-template-columns: 1fr;
                    grid-auto-flow: row;
                }
            }

            .summaryItem {
                justify-content: center;
                align-content: center;
            }

            .summaryItem:last-child {
                border: none;
            }
        `,
];
__decorate([
    property({ type: String })
], SDBContentSummary.prototype, "bg", void 0);
__decorate([
    property({ type: String })
], SDBContentSummary.prototype, "bgColor", void 0);
__decorate([
    property({ type: Boolean })
], SDBContentSummary.prototype, "noPadding", void 0);
__decorate([
    property({ type: Boolean })
], SDBContentSummary.prototype, "equalWidthColumns", void 0);
SDBContentSummary = __decorate([
    customElement('sdb-content-summary')
], SDBContentSummary);
export { SDBContentSummary };
//# sourceMappingURL=sdb-content-summary.js.map